<template>
	<v-container style="padding: 0;">
		<v-dialog title="课时余额不足提醒" v-model="hideShow" width="1000px" persistent>
			<v-card>
				<v-card-title>
					<span>课时余额不足提醒</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1 mt-5"
						disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" no-data-text="暂无数据">
						
						<!-- <template v-slot:item.action="{item}">
							<v-btn small color="info" @click="showRecharge(item)">缴费</v-btn>
						</template> -->
					
					</v-data-table>
					<div class="pt-2">
						<v-row dense>
							<v-col cols="2" >
								<v-select :items="[10, 20, 50, 100]" @change="handleSizeChanged" dense hide-details label="每页数量"
									outlined v-model="query.size" />
							</v-col>
							<v-col cols="1" class="mt-2">
								<span>共{{data.total}}项</span>
							</v-col>
							<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
								<v-pagination :length="Math.ceil(data.total/query.size)" @input="handlePageChanged"
									total-visible="5" v-model="query.page" />
							</v-col>
						</v-row>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"course-account-warn",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
		},
		watch:{
			show(newVal,oldVal){
				this.hideShow = newVal;
				if(this.hideShow){
					this.getDataList();
				}
			}
		},
		data(){
			return {
				query:{
					page:1,
					size:10
				},
				hideShow:this.show,
				shopId:"",
				data: {
					total:0,
					headers:[
						{
							text: '课程名称',
							value: 'courseName',
							sortable: false
						},
						{
							text: '学号',
							value: 'studentNo',
							sortable: false
						},
						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '联系手机',
							value: 'contactorMobile',
							sortable: false
						},
						{
							text: '总课时',
							value: 'totalClassHour',
							sortable: false
						},
						{
							text: '已用课时',
							value: 'usedClassHour',
							sortable: false
						},
						{
							text: '剩余课时',
							value: 'balanceHour',
							sortable: false
						},
					],
					list:[],
					
				},
				
			}
		},
		mounted() {
			console.log("course-account-warn mounted");
			this.shopId = utils.getCurrentShopId();
			this.getDataList();
		
		},
		methods:{
			handleSizeChanged(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getDataList();
			},
			handlePageChanged(page) {
				this.query.page = page;
				this.getDataList();
			},
			getDataList(){
				const that = this;
				const classId = this.classId;
				let url = `/report/course/account/warning/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if(this.shopId){
					url += "&shopId="+this.shopId;
				}
					
				this.axios.get(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						console.log(response.data);
						
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						return
					}
				})
			},
			cancel(){
				this.$emit("cancel","")
			},

		}
	}
	
</script>


<style>
</style>
